
import { PackageActions, PackageActionTypes } from '../actions/package.actions';
import {UserPackages} from '../purchase.model';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: UserPackages[];
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: []
};

export function reducer(state = initialState, action: PackageActions): State {
  switch (action.type) {
    case PackageActionTypes.GetPackages:
      return {...state, isLoaded: false, isLoading: true};

    case PackageActionTypes.LoadPackages:
      return {...state, isLoaded: true, isLoading: false, entities: action.payload};

    case PackageActionTypes.GetPackagesFail:
      return {...state, isLoaded: false, isLoading: false, entities: []};

    default:
      return state;
  }
}
